import { Injectable } from '@angular/core';
import {Idiomas} from '../dominio/idiomas/idiomas';
import {Response} from '../dominio/Response';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {ApiService} from './api.service';
import {Subject} from 'rxjs/Subject';
import {StaticLenguage} from '../dominio/staticLenguage';
import {ItemCombo} from '../dominio/itemCombo';
@Injectable()
export class StaticLenguageService {
    // Observado
    private staticLenguage = new Subject<StaticLenguage>();
    private tipos = new Subject<ItemCombo[]>();

    // Observador
    public staticLenguage$ = this.staticLenguage.asObservable();
    public tipos$ = this.tipos.asObservable();
    constructor(private apiService: ApiService, private toastr: ToastrService, private router: Router) {
    }

    public setLenguages() {
        this.apiService.get('terms')
            .subscribe(  (response: Response) => {
              this.crearStaticLenguage(response.data);
            }, error => {
                this.toastr.error(error.error.data, 'Error');
            });
    }
    public getCombo() {
        this.apiService.get('comboTipo')
            .subscribe(  (response: Response) => {
                console.log(response);
                this.crearTiposCombo(response.data);
            }, error => {
                this.toastr.error(error.error.data, 'Error');
            });
}

    private crearStaticLenguage(data) {
        const staticLenguage = new StaticLenguage();
        staticLenguage.appTitulo = data.appTitulo;
        staticLenguage.formNombre = data.formNombre;
        staticLenguage.formPalabrasClave = data.formPalabrasClave;
        staticLenguage.formUnidadesAcademicas = data.formUnidadesAcademicas;
        staticLenguage.formTipo = data.formTipo;
        staticLenguage.formTitulo = data.formTitulo;
        staticLenguage.regresar = data.regresar;
        staticLenguage.textInicio1 = data.textInicio1;
        staticLenguage.textInicio2 = data.textInicio2;
        staticLenguage.verMas = data.verMas;
        this.staticLenguage.next(staticLenguage);
    }
    private crearTiposCombo(data) {
        const tiposCombo = [];
        for (const item of data) {
            tiposCombo.push(new ItemCombo(item));
        }
        this.tipos.next(tiposCombo);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/static-lenguage.service.ts